// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-89ea60e4] strong{font-weight:700}[data-v-89ea60e4] ol,[data-v-89ea60e4] ul{padding:revert}", ""]);
// Exports
module.exports = exports;
